import { Col, Row, Switch, Select, Form } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from 'react';

import { settingsType } from "./settingsType";
import {
  getIsGridViewLS, setIsGridViewLS,
  getIsComplexPassword, setIsComplexPassword,
  getIsPrintReceipt, setIsPrintReceipt,
  getReceiptLangLS, setReceiptLangLS,
  getReceiptCurrLS, setReceiptCurrLS
} from "../../utils/main-utils";
import LanguageSelector from "./LanguageSelector";
import { useLanguage } from "../ContextAPI/LanguageContext";

type Props = {
  settings: settingsType | undefined;
  countries: any;
  loadingCountries: any;
};

const Customer: React.FC<Props> = ({ settings, countries, loadingCountries }: Props) => {
  const [t] = useTranslation("common");
  const [gridView, setGridView] = useState<boolean>(getIsGridViewLS());
  const [complexPassword, setComplexPassword] = useState<boolean>(getIsComplexPassword());
  const [printReceipt, setPrintReceipt] = useState<boolean>(getIsPrintReceipt());
  const { lang, setLang } = useLanguage();
  const [receiptLang, setReceiptLang] = useState<string | undefined>(getReceiptLangLS())

  const [receiptCurr, setReceiptCurr] = useState<string | undefined>(getReceiptCurrLS())

  const countriesDropdown = countries?.map((item: any) => {
    if (item.isActive) {
      return {
        label: item.name,
        value: item.id
      }
    } else return null
  })

  enum LangCode {
    ar = 'ar',
    en = 'en'
  }

  enum CurrCode {
    usd = 'usd',
    lbp = 'lbp'
  }

  const handleToggleGridView = (checked: boolean) => {
    setGridView(checked);
    setIsGridViewLS(checked);
  };

  const handleToggleComplexPassword = (checked: boolean) => {
    setComplexPassword(checked);
    setIsComplexPassword(checked);
  };

  const handleTogglePrintReceipt = (checked: boolean) => {
    setPrintReceipt(checked)
    setIsPrintReceipt(checked);
  };

  const handleReceiptLanguageChange = (value: string) => {
    setReceiptLang(value)
    setReceiptLangLS(value)
  }

  const handleReceiptCurrChange = (value: string) => {
    setReceiptCurr(value)
    setReceiptCurrLS(value)
  }

  return (
    <Row>
      <Col span={6}>
        <Form.Item name="language" label={`${t("preferred-language")}`}>
          <LanguageSelector lang={lang} setLang={setLang} />
        </Form.Item>

        <Form.Item name="receiptLanguage" label={`${t("receipt-language")}`} initialValue={receiptLang}>
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={t('select-language')}
            options={[
              { value: LangCode.en, label: t('english') },
              { value: LangCode.ar, label: t('arabic') },
            ]}
            onChange={handleReceiptLanguageChange}
            value={receiptLang}
          />
        </Form.Item>

        <Form.Item name="mainCountry" label={`${t("main-country")}`}>
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={t("select-country")}
            loading={loadingCountries}
          >
            {countriesDropdown &&
              countriesDropdown.map((country: any) => (
                <Select.Option key={country.value} value={country.value}>
                  {country.label}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item name="receiptCurr" label={`${t("receipt-curr")}`} initialValue={receiptCurr}>
          <Select
            showSearch
            optionFilterProp="label"
            placeholder={t('select-language')}
            options={[
              { value: CurrCode.usd, label: t('USD') },
              { value: CurrCode.lbp, label: t('LBP') },
            ]}
            onChange={handleReceiptCurrChange}
            value={receiptCurr}
          />
        </Form.Item>

        <Form.Item label={`${t("grid-view")}`}>
          <Switch onChange={handleToggleGridView} checked={gridView} />
        </Form.Item>

        <Form.Item label={`${t("complex-password")}`}>
          <Switch onChange={handleToggleComplexPassword} checked={complexPassword} />
        </Form.Item>

        <Form.Item label={`${t("print-receipt")}`}>
          <Switch onChange={handleTogglePrintReceipt} checked={printReceipt} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default Customer;
